import { ComponentProps } from "react";

import classNames from "classnames/bind";
import { useFormContext } from "react-hook-form";

import UIIcon from "../UIIcon";
import styles from "./input.module.scss";

const cx = classNames.bind(styles);

export type InputType = {
    name: string;
    label?: string;
    helperText?: string;
    errorMessage?: string;
    errorClassName?: string;
    canDelete?: boolean;
} & ComponentProps<"input">;

export function Input({
    name,
    type = "text",
    className,
    label,
    helperText,
    errorMessage,
    errorClassName,
    canDelete,
    ...props
}: InputType) {
    const { register, getFieldState, formState, setValue } = useFormContext();

    const onClickDelete = () => {
        name && setValue(name, "");
    };

    const fieldState = getFieldState(name, formState);

    return (
        <div className={cx("input", { "input--canDelete": canDelete })}>
            {label && (
                <label htmlFor={name} className={cx("input__label")}>
                    {label}
                </label>
            )}
            <input
                {...props}
                id={name}
                type={type}
                className={cx("input__field", { hasError: fieldState.error }, className)}
                {...register(name)}
            />
            {canDelete && (
                <div className={cx("input__deleteButton")} onClick={onClickDelete}>
                    <UIIcon icon="Cross" bgColor="" className={cx("input__deleteButton__icon")} />
                </div>
            )}
            <div className={cx("input__errorWrapper")}>
                {fieldState.invalid && (
                    <span className={cx("input__error", errorClassName)}>
                        <UIIcon icon="Error" bgColor="" />
                        {fieldState.error?.message}
                    </span>
                )}
                {helperText && <span className={cx("input__helperText")}>{helperText}</span>}
            </div>
        </div>
    );
}
